import React from 'react';
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from 'react-share';

import facebookShareIcon from '_images/facebook-share-icon.svg';
import linkedInShareIcon from '_images/linkedin-share-icon.svg';
import xShareIcon from '_images/x-share-icon.svg';
import { urlForArticle } from '_utils/articles';

const domain = process.env.GATSBY_WEB_DOMAIN;

export default function ArticleShareSection({ article }) {
  const url = `${domain}${urlForArticle(article)}`;

  return (
    <div className="flex gap-x-1 sm:gap-x-4 items-center">
      <FacebookShareButton url={url}>
        <div className="inline-flex items-center gap-x-2 rounded border border-stroke-input py-2 px-3 lg:py-1 lg:px-4">
          <img src={facebookShareIcon} alt="facebook" />
          <span className="text-base font-semibold hidden lg:inline">
            Share
          </span>
        </div>
      </FacebookShareButton>
      <TwitterShareButton url={url}>
        <div className="inline-flex items-center gap-x-2 rounded border border-stroke-input py-2 px-3 lg:py-1 lg:px-4">
          <img src={xShareIcon} alt="Twitter" />
          <span className="text-base font-semibold hidden lg:inline">
            Tweet
          </span>
        </div>
      </TwitterShareButton>
      <LinkedinShareButton url={url}>
        <div className="inline-flex items-center gap-x-2 rounded border border-stroke-input py-2 px-3 lg:py-1 lg:px-4">
          <img src={linkedInShareIcon} alt="LinkedIn" className="h-4 w-4" />
          <span className="text-base font-semibold hidden lg:inline">Post</span>
        </div>
      </LinkedinShareButton>
    </div>
  );
}
